import React from "react";
import { Link } from "react-router-dom";

// UI Components
import { Card, CardHeader, CardTitle, ListGroup, ListGroupItem } from "reactstrap";

const TYPES = [
  { label: "Profile", view: "profile" },
  { label: "Security", view: "security" },
  // { label: "Notifications", view: "notifications" },
  // { label: "Delete account", view: "delete" },
];

const AccountNavigation = ({ selected }) => (
  <Card>
    <CardHeader>
      <CardTitle tag="h5" className="mb-0">
        Profile Settings
      </CardTitle>
    </CardHeader>

    <ListGroup flush>
      {TYPES.map(({ label, view }) => (
        <ListGroupItem key={view} tag={Link} to={view} action active={view === selected}>
          {label}
        </ListGroupItem>
      ))}
    </ListGroup>
  </Card>
);

export default AccountNavigation;
